import { render, staticRenderFns } from "./DonutStatPerVirtualSiteChart.vue?vue&type=template&id=a1dd427a"
import script from "./DonutStatPerVirtualSiteChart.vue?vue&type=script&lang=js"
export * from "./DonutStatPerVirtualSiteChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports